import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { auth, db } from '../../../firebase'

function ProfileEdit({ firstName, lastName, phoneNumber }) {
    const [phone, setPhone] = useState(`${phoneNumber}`)
    const [firstName1, setFirstName1] = useState(`${firstName}`)
    const [lastName1, setLastName1] = useState(`${lastName}`)

    const update = () =>{
        try{
          // Set the "capital" field of the city 'DC'
  db.collection("users").doc(auth?.currentUser?.uid).update({
    firstName: firstName1,
    lastName:lastName1,
    phoneNumber:phone
  })
  toast.success("Successfully Updated your details")
        }catch(error){
          toast.error("Error @Updating: ",error.message)
        }
  }
  return (
    <div>
                    <form>
              <div className="form-row">
                <div className="form-group col-md-12">
                  <label>First Name
                  </label>
                  <input type="text" 
                              value={firstName1}
                              onChange={e => setFirstName1(e.target.value)}
                   className="form-control" />
                </div>
                <div className="form-group col-md-12">
                  <label>Last Name
                  </label>
                  <input type="text" value={lastName1} className="form-control"
                        onChange={e => setLastName1(e.target.value)}
                               />
                </div>
                <div className="form-group col-md-12 mb-0">
                  <label>Phone Number
                  </label>
                  <input type="text" value={phone} className="form-control" 
                      onChange={e => setPhone(e.target.value)}
                  />
                </div>
              </div>
            </form>
            <center>
            <button type="button" onClick={update} style={{marginTop:5}} className="btn d-flex w-50 text-center justify-content-center btn-primary">UPDATE</button>

            </center>
    </div>
  )
}

export default ProfileEdit